
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/business-model/done",
      function () {
        return require("private-next-pages/download/business-model/done/index.tsx");
      }
    ]);
  